import React from "react";
import { ThreeDots } from "react-loader-spinner";
import { primaryActionColor } from "../utils/constants";

function Loading() {
  return (
    <ThreeDots
      visible={true}
      height="80"
      width="80"
      color={primaryActionColor}
      radius="9"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClass=""
    />
  );
}

export default Loading;
